import type { Instrument, ReservationRules } from '../services/api';
import type { EndUsePhotoGroup, EndUseRecord } from '../services/api';

export type EndUseRulesSource = Pick<Instrument, 'reservationRules'> | Instrument | null | undefined;

export type EndUsePayload = ReturnType<typeof buildEndUsePayload>;

export function getEndUseRules(instrument?: EndUseRulesSource) {
  const rules = instrument?.reservationRules;
  return {
    enabled: Boolean(rules?.endUseStatusEnabled),
    photoGroups: rules?.endUsePhotoGroups || []
  };
}

export function reservationHasEndUseRecord(reservation: { endUseRecord?: EndUseRecord | null }): boolean {
  const rec = reservation.endUseRecord;
  if (!rec?.submittedAt) return false;
  const hasPhotos = (rec.photoGroups || []).some((g) => g.urls && g.urls.length > 0);
  return hasPhotos || Boolean(rec.notes?.trim());
}

export function getInstrumentFromReservation(
  reservation: { instrumentId?: string | Instrument }
): Instrument | null {
  const ins = reservation.instrumentId;
  if (ins && typeof ins === 'object') return ins;
  return null;
}

export function defaultPhotoGroupsState(groups: EndUsePhotoGroup[]): Record<string, string[]> {
  const out: Record<string, string[]> = {};
  groups.forEach((g) => {
    out[g.key] = [];
  });
  return out;
}

export function photoGroupsFromRecord(
  record: EndUseRecord | undefined,
  configGroups: EndUsePhotoGroup[]
): Record<string, string[]> {
  const base = defaultPhotoGroupsState(configGroups);
  (record?.photoGroups || []).forEach((g) => {
    if (g.groupKey) base[g.groupKey] = [...(g.urls || [])];
  });
  return base;
}

export function buildEndUsePayload(
  notes: string,
  photoUrlsByGroup: Record<string, string[]>,
  configGroups: EndUsePhotoGroup[]
) {
  return {
    notes: notes.trim(),
    photoGroups: configGroups.map((g) => ({
      groupKey: g.key,
      label: g.label,
      urls: photoUrlsByGroup[g.key] || []
    }))
  };
}
